// extracted by mini-css-extract-plugin
export var boxItems = "_1g-1";
export var button = "_1g-5";
export var filterGroupBox = "_1g-0";
export var icon = "_1g-2";
export var iconSecondary = "_1g-4";
export var iconWrapper = "_1g-3";